"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _strings = require("./strings");

var _KesiLogIn = _interopRequireDefault(require("../KesiLogIn/KesiLogIn.scss"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _UserManagementService = _interopRequireDefault(require("../../components/Equizzer/services/UserManagementService"));

var _Feature = _interopRequireDefault(require("../../../utils/features/Feature"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _AppChannel = require("../../../KESI2/Services/AppChannel");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TeamsLogIn = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TeamsLogIn, _React$Component);

  var _super = _createSuper(TeamsLogIn);

  function TeamsLogIn(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TeamsLogIn);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMessageForThisApp", function (message) {
      var command = message.name;

      if (!_this.state.currentlyHandlingReset) {
        console.log('EurofhLogIn message for this app', message.data);

        if (command === 'allowPasswordReset') {
          _this.setState({
            currentlyHandlingReset: true
          });

          _this.hideWaitingDialog();

          _this.showNewPasswordDialog(message.data);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkActivationCode", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(id) {
        var code, returnValue, featureName, feature, data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                code = id ? id : _this.state.activationCode ? _this.state.activationCode : false;
                console.log('checkActivationCode', code);

                if (!code) {
                  _context.next = 29;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return _UserManagementService["default"].checkSnomId(code);

              case 6:
                returnValue = _context.sent;
                featureName = returnValue && returnValue.features ? returnValue.features.join(',') : _config["default"].requiredFeature;
                console.log('EurofhLogin.checkActivationCode', returnValue, code, featureName);
                feature = new _Feature["default"](featureName, code, returnValue.user.username, null, returnValue.user.additionalData); // LoadFromServer has to be run first -> if saveFeature is first, a new public store will be saved (and uploaded) -> retrieve will always get the last store that we just sent

                _context.next = 12;
                return _DataStore["default"].loadFromServer(_DataStore.DATA_STORE_PATHS.PUBLIC);

              case 12:
                _context.next = 14;
                return _FeatureManager["default"].saveFeature(feature);

              case 14:
                data = {};
                _context.next = 17;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 17:
                data[_DataStore.DATA_STORE_PATHS.KESI_ACTIVE_DEVICE] = _context.sent;
                data[_DataStore.DATA_STORE_PATHS.LOGGED_IN] = true;
                _context.next = 21;
                return _DataStore["default"].setData(data);

              case 21:
                _this.setState({
                  activated: true,
                  userName: returnValue.username,
                  nickName: returnValue.nickname || null,
                  feature: featureName,
                  loading: false,
                  activationCode: code
                }); // setTimeout(() => {
                //   this.showWelcomeDialog()
                // })


                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](3);

                if (_context.t0.message && _context.t0.message.match(_HttpRequest.HTTP_ERROR_PREFIX)) {
                  (0, _AlertHelper.showWideAlertHtml)('ERROR', (0, _ErrorHelper.getErrorMessage)(_context.t0.message));
                } else {
                  _this.setState({
                    activated: false,
                    loading: false
                  });
                }

              case 27:
                _context.next = 31;
                break;

              case 29:
                _this.setState({
                  activated: false,
                  loading: false
                });

                setTimeout(function () {
                  (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('EUROFH_NO_PORTAL_TEXT'), (0, _strings.getString)('EUROFH_NO_PORTAL_TITLE'));
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 24]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.state = {
      loading: true,
      activated: false,
      userAgreed: false,
      reset: false,
      userChanged: false,
      currentlyHandlingReset: false
    };
    _this.hideWaitingDialog = null;
    return _this;
  }

  (0, _createClass2["default"])(TeamsLogIn, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this2 = this;

        var clientId, clientSecret, scope, msalConfig, msalInstance;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                clientId = '09a5f406-0293-440b-9a6a-3f758903d456';
                clientSecret = 'SFJ8Q~ifyVWrj11dRPlh1x6mWhJA7oVIf0vmydAE';
                scope = 'user.read';
                msalConfig = {
                  auth: {
                    clientId: clientId,
                    authority: clientSecret,
                    redirectUri: window.location.origin
                  },
                  cache: {
                    cacheLocation: "localStorage",
                    storeAuthStateInCookie: false
                  }
                };

                if (!(!msal || !microsoftTeams)) {
                  _context3.next = 7;
                  break;
                }

                console.log('cant find msal or microsoftTeams');
                return _context3.abrupt("return");

              case 7:
                msalInstance = new msal.PublicClientApplication(msalConfig);
                microsoftTeams.app.initialize().then(function () {
                  microsoftTeams.app.getContext().then( /*#__PURE__*/function () {
                    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(context) {
                      var user, loggedIn;
                      return _regenerator["default"].wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              user = msalInstance.getAccountByUsername(context.user.userPrincipalName);
                              loggedIn = !!user;

                              if (loggedIn) {
                                _context2.next = 6;
                                break;
                              }

                              microsoftTeams.authentication.authenticate({
                                url: window.location.origin + "/auth-start.html?clientId=".concat(clientId, "&scope=").concat(scope),
                                successCallback: function successCallback(result) {
                                  console.log('teamsLogin login ok: ' + result);
                                  window.location.reload();
                                },
                                failureCallback: function failureCallback(reason) {
                                  console.log('teamsLogin error auth: ' + reason);
                                }
                              });
                              _context2.next = 10;
                              break;

                            case 6:
                              // render username
                              console.log('teamsLogin user: ', user);

                              if (!(user && user.localAccountId)) {
                                _context2.next = 10;
                                break;
                              }

                              _context2.next = 10;
                              return _this2.checkActivationCode(user.localAccountId);

                            case 10:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _AppChannel.unregister)(this.onMessageForThisApp);
    }
  }, {
    key: "showWelcomeDialog",
    value: function showWelcomeDialog() {
      (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('USER_WELCOME'), (0, _strings.getString)('USER_WELCOME_TITLE'), false, [{
        label: (0, _strings.getString)('OK'),
        callback: function callback() {
          setTimeout(function () {});
        }
      }]);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _KesiLogIn["default"].logInInfo
      }, _config["default"].useLoginGraphics && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _KesiLogIn["default"].logInText
      }, _config["default"].defaultNavbarTitle), /*#__PURE__*/_react["default"].createElement("div", {
        className: _KesiLogIn["default"].tileBackground
      })));
    }
  }]);
  return TeamsLogIn;
}(_react["default"].Component);

var _default = TeamsLogIn;
exports["default"] = _default;